import { l } from 'src/utils/helper';

const inputAttachments = 'inputAttachments';

export default {
  add(activityId, temporaryId, attachment) {
    const currentList = localStorage.getItem(inputAttachments);
    let updList = {};
    try {
      updList = currentList ? JSON.parse(currentList) : {};
    } catch (err) {
      l.error(`Input attachment localStorage adding error. Activity Id: ${activityId}`);
      l.error(err);
    }
    updList[activityId] = {
      ...updList[activityId],
      [temporaryId]: attachment,
    };
    localStorage.setItem(inputAttachments, JSON.stringify(updList));
  },
  update(activityId, temporaryId, attachment) {
    const currentList = localStorage.getItem(inputAttachments);
    let updList = {};
    try {
      updList = currentList ? JSON.parse(currentList) : {};
    } catch (err) {
      l.error(`Input attachment localStorage updating error. Activity Id: ${activityId}`);
      l.error(err);
    }
    updList[activityId] = {
      ...updList[activityId],
      [temporaryId]: {
        ...updList[activityId][temporaryId],
        ...attachment,
      },
    };
    localStorage.setItem(inputAttachments, JSON.stringify(updList));
  },
  get(activityId) {
    const inputList = JSON.parse(localStorage.getItem(inputAttachments));
    return inputList ? inputList[activityId] : null;
  },
  remove(activityId, temporaryId) {
    const currentList = localStorage.getItem(inputAttachments);
    let updList = {};
    try {
      updList = currentList ? JSON.parse(currentList) : {};
    } catch (err) {
      l.error(`Input attachment localStorage remove error. Activity Id: ${activityId}`);
      l.error(err);
    }
    if (updList[activityId] && updList[activityId][temporaryId]) {
      delete updList[activityId][temporaryId];
    }
    localStorage.setItem(inputAttachments, JSON.stringify(updList));
  },
  clear(activityId) {
    const currentList = localStorage.getItem(inputAttachments);
    let updList = {};
    try {
      updList = currentList ? JSON.parse(currentList) : {};
    } catch (err) {
      l.error(`Input attachment localStorage clear error. Activity Id: ${activityId}`);
      l.error(err);
    }
    if (updList[activityId]) {
      delete updList[activityId];
    }
    localStorage.setItem(inputAttachments, JSON.stringify(updList));
  },
  clearAll() {
    localStorage.removeItem(inputAttachments);
  },
};
